import * as React from "react";
const ObjectPositionLeftSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 8v1H9V8h7Zm-9 .5a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1 5 0Zm-1 0C6 7.67 5.33 7 4.5 7S3 7.67 3 8.5 3.67 10 4.5 10 6 9.33 6 8.5Z" }));
ObjectPositionLeftSmall.displayName = "ObjectPositionLeftSmall";
var ObjectPositionLeftSmall_default = ObjectPositionLeftSmall;
export {
  ObjectPositionLeftSmall_default as default
};
